

<!-- Email Preview Container -->
<div  class="preview-container">

  <!-- Loading Spinner -->
  <div *ngIf="isLoading" class="loading-container" >
    <ion-spinner name="crescent"></ion-spinner>
    <div class="loading-message">{{loadingMessage}}</div>
  </div>

  <!-- Email Window -->
  <div class="email-window" >

    <!-- Expediting-email notice: this log had missing/damaged items -->
    <div class="expediting-notice" *ngIf="hasExpeditingEmail && !isLoading">
      <ion-icon name="warning"></ion-icon>
      <span>
        This log has missing or damaged items — a separate expediting email was
        sent to the expediting inbox when it was originally submitted.
      </span>
    </div>

    <!-- Email Header Bar -->
    <div class="email-header-bar">
      <ion-text>
        <h2>{{emailContent.subject}}</h2>
      </ion-text>
    </div>

    <!-- Email Content -->
    <div class="email-content">

      <!-- Sender Section -->
      <div class="email-section">
        <div class="section-header">
          <ion-text color="medium">
            <h3>Sender</h3>
          </ion-text>
        </div>
        <div class="section-content">
          <div class="recipient-row">
            <ion-text color="medium" class="label">From:</ion-text>
            <ion-text class="value">
              <span>{{emailContent.senderEmail}}</span>
            </ion-text>
          </div>
          
        </div>
      </div>

      <!-- Recipients Section -->
      <div class="email-section">
        <div class="section-header">
          <ion-text color="medium">
            <h3>Recipients</h3>
          </ion-text>
        </div>
        <div class="section-content">
          <div class="recipient-row">
            <ion-text color="medium" class="label">To:</ion-text>
            <ion-text class="value">
              <span *ngFor="let recipient of emailContent.recipients; let last = last">
                {{recipient}}{{!last ? ', ' : ''}}
              </span>
            </ion-text>
          </div>
          
        </div>
      </div>

      <!-- Attachment Section -->
      <div class="email-section">
        <div class="section-header">
          <ion-text color="medium">
            <h3>Attachments</h3>
          </ion-text>
        </div>
        <div class="section-content">
          <div class="toggle-row">
            <ion-toggle
              [(ngModel)]="includePhotosInEmail" 
              (ionChange)="handleTogglePhotosInEmail($event)">
            </ion-toggle>
            <ion-text color="medium">
              <p>Include photos in email</p>
            </ion-text>
          </div>

          <div class="attachment-chips">
            <!-- Show photos if included and available -->
            <ng-container *ngIf="includePhotosInEmail && photos.length > 0">
              <ion-chip *ngFor="let photo of photos" class="attachment-chip" [clickable]="false">
                <ion-avatar>
                  <img [src]="photo.url" [alt]="photo.name">
                </ion-avatar>
                <ion-label>{{photo.name}}</ion-label>
              </ion-chip>
            </ng-container>
            <!-- Show message if no photos or photos not included -->
            <div *ngIf="!includePhotosInEmail || photos.length === 0" class="no-attachments-message">
              <ion-text color="medium">
                <p>{{!includePhotosInEmail ? 'Photos are not included in this email' : 'No photos were attached to this log entry'}}</p>
              </ion-text>
            </div>
          </div>
        </div>
      </div>

      <!-- Email Body Section -->
      <div class="email-section">
        <div class="section-header">
          <ion-text color="medium">
            <h3>Message</h3>
          </ion-text>
        </div>
        <div class="section-content">
          <div [innerHTML]="emailContent.htmlBody | targetBlank" class="email-body"></div>
        </div>
      </div>
    </div>
  </div>
</div>
